import React, { createContext, useCallback, useContext, useState } from 'react';

const AuthModalContext = createContext({
  open: false,
  mode: 'signin',
  openAuth: () => {},
  closeAuth: () => {},
});

export function AuthModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('signin');

  const openAuth = useCallback((nextMode = 'signin') => {
    setMode(nextMode);
    setOpen(true);
  }, []);

  const closeAuth = useCallback(() => setOpen(false), []);

  return (
    <AuthModalContext.Provider value={{ open, mode, openAuth, closeAuth, setMode }}>
      {children}
    </AuthModalContext.Provider>
  );
}

export function useAuthModal() {
  return useContext(AuthModalContext);
}
